<template>
  <div>
    <li class="u-item clearfix">
      <div class="u-avatar">
        <router-link
          :to="{ path: '/home', query: { userId: commentOBj.commentAuthor } }"
          class="avatar-f"
        >
          <img :src="commentOBj.imgUrl" alt="" />
        </router-link>
        <!--      <div class="hot-fire"></div>-->
      </div>
      <div class="u-infoes">
        <div class="u-name-title clearfix">
          <router-link
            :to="{ path: '/home', query: { userId: commentOBj.commentAuthor } }"
            class="name"
            >{{ commentOBj.commentAuthorName }}</router-link
          >
          <div
            class="new-tchh clearfix"
            v-if="
              commentOBj.commentAuthorRankName != '' &&
                commentOBj.commentAuthorRankName != 'null' &&
                commentOBj.commentAuthorRankName != null
            "
          >
            <i
              class="icon zs"
              v-if="
                commentOBj.commentAuthorRankName.split(',')[1] == '资深作者'
              "
            ></i>
            <i
              class="icon yx"
              v-if="
                commentOBj.commentAuthorRankName.split(',')[1] == '优秀作者'
              "
            ></i>
            <i
              class="icon hy"
              v-if="
                commentOBj.commentAuthorRankName.split(',')[1] == '活跃作者'
              "
            ></i>
            <span class="zuoz">{{
              commentOBj.commentAuthorRankName.split(",")[1]
            }}</span>
            <span class="shu">|</span>
            <span class="liny">{{
              commentOBj.commentAuthorRankName.split(",")[0]
            }}</span>
          </div>
        </div>
<!--
        <div class="words">
          {{ commentOBj.commentContent }}
        </div>
-->
	<div v-html="commentOBj.commentContent" ></div>

        <div class="zan-cai-date clearfix">
          <div class="zan-cai" v-if="isLogin">
            <div class="item" :class="{ active: commentOBj.likeFlag }">
              <span class="zc-icon zan" @click="likeEvent(commentOBj)"></span>
              <span class="count"> {{ commentOBj.likeCount }}</span>
            </div>
            <!--<div class="item">-->
            <!--<span class="zc-icon cai"></span>-->
            <!--<span class="count">201</span>-->
            <!--</div>-->
            <div class="item" @click="pinglunSecEvent(commentOBj)">
              <span class="zc-icon pinglun"></span>
              <span class="count">{{total}}</span>
            </div>
            <div class="item" v-if="loginUserId == commentOBj.commentAuthor">
              <span class="zc-icon shanchu" @click="del(commentOBj)"></span>
            </div>
          </div>
          <div class="date">{{ commentOBj.commentTs | formatTime }}</div>
        </div>
        <template v-if="showThird">
          <el-form :model="formChild" ref="formChild" v-if="!isProView && isLogin">
            <div class="console-ipt" v-if="isShow">
              <el-input
                class="textarea"
                type="textarea"
                :rows="1"
                placeholder="请输入内容"
                v-model="formChild.commentContent"
              >
              </el-input>
              <div class="checked-btn clearfix">
                <!--            <el-checkbox class="checked" v-model="formChild.activitiesAnd">同时转发到我的动态</el-checkbox>-->
                <el-button
                  class="fabu-btn"
                  type="primary"
                  size="mini"
                  @click="submitChild"
                  v-if="isLogin"
                  >发布</el-button
                >
                <el-button
                  class="fabu-btn"
                  type="primary"
                  size="mini"
                  @click="toLog"
                  v-else
                  >请登录</el-button
                >
              </div>
            </div>
          </el-form>
          <div class="huifu-list" v-if="listDate.length > 0">
            <div v-for="(item, index) in listDate" :key="index">
              <talk-fourth
                :obj="item"
                v-if="isReload"
                :isProView="isProView"
              ></talk-fourth>
            </div>
            <div class="see-more" @click="getChild" v-if="showMore">
              更多回复
            </div>

            <!--          <talk-fourth></talk-fourth>-->
            <!--          <talk-fourth></talk-fourth>-->
            <!--          <div class="see-more">更多回复</div>-->
          </div>
          <!--        <pagination v-if="loadShow" v-show="total>0" :total="total" :page.sync="commonParam.pageIndex" :limit.sync="commonParam.pageSize"-->
          <!--                    @pagination="getChild" style="text-align: center"/>-->
        </template>
      </div>
    </li>
  </div>
</template>

<script type="text/ecmascript-6">
import talkFourth from '@@/pub/talkfourth/talkfourth'
import commentApi from '@/api/comment'
import apiService from '@/api/index'
// import Pagination from '@/components/Pagination'
export default {
  props: {
  objType: {
    type: Number,
    //required: true,
  },
  objId: {
    type: Number,
    //required: true,
  },
  commentAuthorRankId: {
    type: Number,
    //required: true,
  },
  obj:{
    type:Object,
  },
  isProView:{
    type:Boolean
  },
  loadShow:{
    type:Boolean
  }
  },
  components: {
    talkFourth
  },
  data () {
    return {
      callbackurl:"",
      showMore:true,
      total:0,
      listDate:[],
      isShow:true,
      isReload:true,
      showThird: false,
      textConThird: '',
      commentOBj:{},
      loginUserId:0,
      isLogin:false,
      commonParam:{
        commentObjectId:this.obj.commentObjectId,
        commentObjectType:this.obj.commentObjectType,
        commentAuthorRankId:this.obj.commentAuthorRankId,//评论者等级id 大于1为专家//0为普通
        commentParent:this.obj.commentParent,//0为父级评论
        pageIndex: 1,
        pageSize: 3,
      },
      formChild:{
        commentObjectId:this.obj.commentObjectId,
        commentObjectType:this.obj.commentObjectType,
        commentParent:-1,//0为父级评论
        commentContent:'',
        commentAuthor:0,

        commentParentAuthorName:'',
        commentParentAuthor:0,
        commentParentRankId:'',
        commentParentRankName:'',
        activitiesAnd:false,
      }
    }
  },
  mounted(){
    this.callbackurl="login?callback="+window.location.href;
    let this_ = this
    if(this.global.isLogin){
      this_.loginUserId = this.global.userModel.id
      this_.isLogin = true
    }
    this_.commentOBj = this.obj

    if(this.loadShow){
      this.pinglunSecEvent(this_.commentOBj)
    }else {
      this.pinglunSecEventBak(this_.commentOBj)
    }


  },
  methods: {
    getChild(){
      let this_ = this
      commentApi.getPageList(this_.commonParam).then(reChild => {
        reChild.list.forEach((item) => {
          //console.log("item.id====",item.id)
          this_.listDate.push(item)
        })


        //console.log("getChild.listDate=oo========",this_.listDate)

        this_.total = reChild.total
        if(this_.commonParam.pageIndex == Math.ceil(this_.total/this_.commonParam.pageSize)){
          this_.showMore =false
        }else{
          this_.commonParam.pageIndex = this.commonParam.pageIndex +1
        }


        // 移除组件
        this_.isReload = false
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this_.$nextTick(() => {
          this_.isReload = true
        })

      })
    },
    pinglunSecEvent (item) {
      this.showThird = !this.showThird
      if(this.showThird){
        this.isShow = true
      }
      if(item){
        this.commonParam.commentParent = item.id
        this.formChild.commentParent = item.id

        this.formChild.commentParentAuthorName = item.commentAuthorName
        this.formChild.commentParentAuthor = item.commentAuthor
        if(item.commentAuthorRankId){
          this.formChild.commentParentRankId = item.commentAuthorRankId
          this.formChild.commentParentRankName = item.commentAuthorRankName
        }
      }
      this.setEmpty()
    },

    pinglunSecEventBak (item) {

      if(item){
        this.commonParam.commentParent = item.id
        this.formChild.commentParent = item.id

        this.formChild.commentParentAuthorName = item.commentAuthorName
        this.formChild.commentParentAuthor = item.commentAuthor
        if(item.commentAuthorRankId){
          this.formChild.commentParentRankId = item.commentAuthorRankId
          this.formChild.commentParentRankName = item.commentAuthorRankName
        }
      }
      this.setEmpty()
    },

    //发布子留言
    submitChild( ){
      let this_ = this
console.log("third==============");
      if(this_.formChild.commentContent.trim() == ''){
        this_.$notify({
          title: "留言不能为空",
          type: 'error',
          showClose: false,
          duration: 2000
        })
        return false;
      }

      this_.formChild.commentAuthor = this_.loginUserId
      commentApi.update(this_.formChild).then(re =>{
        if(re.code==1){
          this_.formChild.commentContent=''
          this_.setAddCommentNum()
          this_.$notify({
            title: re.message,
            type: 'success',
            showClose: false,
            duration: 2000
          })

          this.setEmpty()
          this.isShow = false
          // 移除组件
          this_.isReload = false
          // 在组件移除后，重新渲染组件
          // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
          this_.$nextTick(() => {
            this_.isReload = true
          })
        }else{
          this_.$notify({
            title: re.message,
            type: 'error',
            showClose: false,
            duration: 2000
          })
        }

        //this_.pinglunSecEvent()
      })
    },
    del(item){
      let this_ = this
      this.$confirm('确认删除吗？')
      .then(_ => {
        console.log(_)
        commentApi.delete(item.id).then(re => {
          if (re.code === 1) {
            this_.$parent.setEmpty();
            this_.setDelCommentNum(re.response)
            this_.$notify({
              title: re.message,
              type: 'success',
              showClose: false,
              duration: 2000
            })
          } else {
            this_.$notify({
              title: re.message,
              type: 'error',
              showClose: false,
              duration: 2000
            })
          }
        })
      })
      .catch(_ => {
         console.log('取消 catch',_)
      })
    },
    likeEvent(item){
      var this_ =this;
      console.debug(this_.isLogin);
      if(this_.isLogin){
        apiService.dolike({"objectType":5,"objectId":item.id,"belongSection":item.belongSection,"time": new Date().getMilliseconds()}).then(data => {
          console.log(data)  //为了不报结构异常
          if(item.likeFlag){
            item.likeCount=item.likeCount-1;
            item.likeFlag=false;
          }else{
            item.likeCount=item.likeCount+1;
            item.likeFlag=true;
          }
        });
      }else{
        window.location.href="http://www.renrendonghua.com/"+this_.callbackurl;
        // this_.$message({
        //   message: '您尚未登录,请登录后操作',
        //   type: 'error'
        // });
      }
    },
    toLog(){
      this.$router.push({
        path:'/login?callback=' + window.location.href,
      })

    } ,
    setEmpty(){
      this.listDate = []
      this.commonParam.pageIndex=1
      this.showMore=true,
      //this.total=0,
      this.getChild();
    },
    setAddCommentNum(){
      this.$parent.setAddCommentNum()
    },
    setDelCommentNum(cutNum){
      this.$parent.setDelCommentNum(cutNum)
    }
  }
}
</script>

<style scoped lang="less"></style>
